var _defs, _rect, _rect2, _g, _polygon, _polygon2, _polygon3, _polygon4, _rect3, _rect4, _line, _line2, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _line3, _rect5, _polygon11, _line4, _rect6, _polygon12, _line5, _rect7, _polygon13, _line6, _rect8, _polygon14, _line7, _rect9, _rect10, _line8, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSituationEscalier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "chaudi\\xE8re",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 3000.5 3001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#D\xE9grad\xE9_sans_nom_57);}.cls-2{fill:#e09a7e;}.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-20,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27,.cls-28,.cls-29,.cls-3,.cls-30,.cls-31,.cls-32,.cls-33,.cls-34,.cls-35,.cls-36,.cls-37,.cls-38,.cls-39,.cls-4,.cls-40,.cls-41,.cls-42,.cls-43,.cls-44,.cls-45,.cls-46,.cls-47,.cls-48,.cls-49,.cls-5,.cls-50,.cls-51,.cls-52,.cls-53,.cls-54,.cls-55,.cls-56,.cls-57,.cls-58,.cls-59,.cls-6,.cls-60,.cls-7,.cls-8,.cls-9{stroke:#594b45;}.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-20,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27,.cls-28,.cls-29,.cls-3,.cls-30,.cls-31,.cls-32,.cls-33,.cls-34,.cls-35,.cls-36,.cls-37,.cls-38,.cls-39,.cls-4,.cls-40,.cls-41,.cls-42,.cls-43,.cls-44,.cls-45,.cls-46,.cls-47,.cls-48,.cls-49,.cls-5,.cls-50,.cls-51,.cls-52,.cls-53,.cls-54,.cls-55,.cls-56,.cls-57,.cls-58,.cls-59,.cls-6,.cls-60,.cls-66,.cls-69,.cls-7,.cls-8,.cls-9{stroke-miterlimit:10;}.cls-3{fill:url(#D\xE9grad\xE9_sans_nom_157);}.cls-4{fill:url(#D\xE9grad\xE9_sans_nom_157-2);}.cls-5{fill:url(#D\xE9grad\xE9_sans_nom_157-3);}.cls-6{fill:url(#D\xE9grad\xE9_sans_nom_157-4);}.cls-7{fill:url(#D\xE9grad\xE9_sans_nom_157-5);}.cls-8{fill:url(#D\xE9grad\xE9_sans_nom_157-6);}.cls-9{fill:url(#D\xE9grad\xE9_sans_nom_157-7);}.cls-10{fill:url(#D\xE9grad\xE9_sans_nom_157-8);}.cls-11{fill:url(#D\xE9grad\xE9_sans_nom_157-9);}.cls-12{fill:url(#D\xE9grad\xE9_sans_nom_157-10);}.cls-13{fill:url(#D\xE9grad\xE9_sans_nom_157-11);}.cls-14{fill:url(#D\xE9grad\xE9_sans_nom_157-12);}.cls-15{fill:url(#D\xE9grad\xE9_sans_nom_157-13);}.cls-16{fill:url(#D\xE9grad\xE9_sans_nom_157-14);}.cls-17{fill:url(#D\xE9grad\xE9_sans_nom_157-15);}.cls-18{fill:url(#D\xE9grad\xE9_sans_nom_157-16);}.cls-19{fill:url(#D\xE9grad\xE9_sans_nom_157-17);}.cls-20{fill:url(#D\xE9grad\xE9_sans_nom_157-18);}.cls-21{fill:url(#D\xE9grad\xE9_sans_nom_157-19);}.cls-22{fill:url(#D\xE9grad\xE9_sans_nom_157-20);}.cls-23{fill:url(#D\xE9grad\xE9_sans_nom_157-21);}.cls-24{fill:url(#D\xE9grad\xE9_sans_nom_157-22);}.cls-25{fill:url(#D\xE9grad\xE9_sans_nom_157-23);}.cls-26{fill:url(#D\xE9grad\xE9_sans_nom_157-24);}.cls-27{fill:url(#D\xE9grad\xE9_sans_nom_157-25);}.cls-28{fill:url(#D\xE9grad\xE9_sans_nom_157-26);}.cls-29{fill:url(#D\xE9grad\xE9_sans_nom_157-27);}.cls-30{fill:url(#D\xE9grad\xE9_sans_nom_157-28);}.cls-31{fill:url(#D\xE9grad\xE9_sans_nom_157-29);}.cls-32{fill:url(#D\xE9grad\xE9_sans_nom_157-30);}.cls-33{fill:url(#D\xE9grad\xE9_sans_nom_157-31);}.cls-34{fill:url(#D\xE9grad\xE9_sans_nom_157-32);}.cls-35{fill:url(#D\xE9grad\xE9_sans_nom_157-33);}.cls-36{fill:url(#D\xE9grad\xE9_sans_nom_157-34);}.cls-37{fill:url(#D\xE9grad\xE9_sans_nom_157-35);}.cls-38{fill:url(#D\xE9grad\xE9_sans_nom_157-36);}.cls-39{fill:url(#D\xE9grad\xE9_sans_nom_157-37);}.cls-40{fill:url(#D\xE9grad\xE9_sans_nom_157-38);}.cls-41{fill:url(#D\xE9grad\xE9_sans_nom_157-39);}.cls-42{fill:url(#D\xE9grad\xE9_sans_nom_157-40);}.cls-43{fill:url(#D\xE9grad\xE9_sans_nom_157-41);}.cls-44{fill:url(#D\xE9grad\xE9_sans_nom_157-42);}.cls-45{fill:url(#D\xE9grad\xE9_sans_nom_157-43);}.cls-46{fill:url(#D\xE9grad\xE9_sans_nom_157-44);}.cls-47{fill:url(#D\xE9grad\xE9_sans_nom_157-45);}.cls-48{fill:url(#D\xE9grad\xE9_sans_nom_157-46);}.cls-49{fill:url(#D\xE9grad\xE9_sans_nom_157-47);}.cls-50{fill:url(#D\xE9grad\xE9_sans_nom_157-48);}.cls-51{fill:url(#D\xE9grad\xE9_sans_nom_157-49);}.cls-52{fill:url(#D\xE9grad\xE9_sans_nom_157-50);}.cls-53{fill:url(#D\xE9grad\xE9_sans_nom_157-51);}.cls-54{fill:url(#D\xE9grad\xE9_sans_nom_157-52);}.cls-55{fill:url(#D\xE9grad\xE9_sans_nom_157-53);}.cls-56{fill:url(#D\xE9grad\xE9_sans_nom_157-54);}.cls-57{fill:url(#D\xE9grad\xE9_sans_nom_157-55);}.cls-58{fill:url(#D\xE9grad\xE9_sans_nom_157-56);}.cls-59{fill:url(#D\xE9grad\xE9_sans_nom_157-57);}.cls-60{fill:url(#D\xE9grad\xE9_sans_nom_157-58);}.cls-61{fill:url(#D\xE9grad\xE9_sans_nom_184);}.cls-62{fill:url(#D\xE9grad\xE9_sans_nom_188);}.cls-63{fill:#f7f7f7;}.cls-64{fill:url(#D\xE9grad\xE9_sans_nom_171);}.cls-65{fill:url(#D\xE9grad\xE9_sans_nom_171-2);}.cls-66,.cls-69{fill:none;}.cls-66{stroke:#dc8863;stroke-width:11px;}.cls-67{fill:#a0a0a0;}.cls-68{fill:#664323;}.cls-69{stroke:#a46e48;stroke-width:3px;}.cls-70{fill:#ccc;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_57",
    x1: 1488.49,
    y1: 3051.98,
    x2: 1511.51,
    y2: 2393.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ababab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c2c2c2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157",
    x1: 1509.5,
    y1: 2871.5,
    x2: 1509.5,
    y2: 2828.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#614533"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#9e775f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#a07860"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#a77d64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#b2866b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#c39376"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#d19d7e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#cf9b7d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#c79678"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#ba8c70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#a77e65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#9e775f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#9e775f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#9e775f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#9e775f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#9e775f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#9e775f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#b1856b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#d19d7e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#cf9c7d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#c89678"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#bd8d70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#ac8065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966e57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7b5a45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70513e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-2",
    x1: 709.5,
    y1: 2871.5,
    x2: 709.5,
    y2: 2828.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-3",
    x1: 2854.5,
    y1: 2871.5,
    x2: 2854.5,
    y2: 2828.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-4",
    x1: 2309.5,
    y1: 2871.5,
    x2: 2309.5,
    y2: 2828.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-5",
    x1: 1937.5,
    y1: 2827.5,
    x2: 1937.5,
    y2: 2784.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-6",
    x1: 1137.5,
    y1: 2827.5,
    x2: 1137.5,
    y2: 2784.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-7",
    x1: 369,
    y1: 2827.5,
    x2: 369,
    y2: 2784.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-8",
    x1: 2668.5,
    y1: 2827.5,
    x2: 2668.5,
    y2: 2784.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-9",
    x1: 2070.26,
    y1: 2784.5,
    x2: 2070.26,
    y2: 2741.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-10",
    x1: 1369.9,
    y1: 2784.5,
    x2: 1369.9,
    y2: 2741.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-11",
    x1: 697.11,
    y1: 2784.5,
    x2: 697.11,
    y2: 2741.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-12",
    x1: 187.56,
    y1: 2784.5,
    x2: 187.56,
    y2: 2741.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-13",
    x1: 2710.22,
    y1: 2784.5,
    x2: 2710.22,
    y2: 2741.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-14",
    x1: 155,
    y1: 2871.5,
    x2: 155,
    y2: 2828.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-15",
    x1: 1137.5,
    y1: 2914.5,
    x2: 1137.5,
    y2: 2871.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-16",
    x1: 1937.5,
    y1: 2914.5,
    x2: 1937.5,
    y2: 2871.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-17",
    x1: 369,
    y1: 2914.5,
    x2: 369,
    y2: 2871.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-18",
    x1: 187.5,
    y1: 2957.5,
    x2: 187.5,
    y2: 2914.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-19",
    x1: 773.5,
    y1: 2957.5,
    x2: 773.5,
    y2: 2914.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-20",
    x1: 1573.5,
    y1: 2957.5,
    x2: 1573.5,
    y2: 2914.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-21",
    x1: 2373.5,
    y1: 2957.5,
    x2: 2373.5,
    y2: 2914.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-22",
    x1: 2668.5,
    y1: 2914.5,
    x2: 2668.5,
    y2: 2871.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-23",
    x1: 405.5,
    y1: 3000.5,
    x2: 405.5,
    y2: 2957.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-24",
    x1: 1209.5,
    y1: 3000.5,
    x2: 1209.5,
    y2: 2957.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-25",
    x1: 2009.5,
    y1: 3000.5,
    x2: 2009.5,
    y2: 2957.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-26",
    x1: 2704.5,
    y1: 3000.5,
    x2: 2704.5,
    y2: 2957.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-27",
    x1: 2886.5,
    y1: 2957.5,
    x2: 2886.5,
    y2: 2914.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-28",
    x1: 1509.5,
    y1: 2612.5,
    x2: 1509.5,
    y2: 2569.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-29",
    x1: 709.5,
    y1: 2612.5,
    x2: 709.5,
    y2: 2569.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-30",
    x1: 2854.5,
    y1: 2612.5,
    x2: 2854.5,
    y2: 2569.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-31",
    x1: 2309.5,
    y1: 2612.5,
    x2: 2309.5,
    y2: 2569.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-32",
    x1: 1937.5,
    y1: 2568.5,
    x2: 1937.5,
    y2: 2525.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-33",
    x1: 1137.5,
    y1: 2568.5,
    x2: 1137.5,
    y2: 2525.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-34",
    x1: 369,
    y1: 2568.5,
    x2: 369,
    y2: 2525.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-35",
    x1: 2668.5,
    y1: 2568.5,
    x2: 2668.5,
    y2: 2525.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-36",
    x1: 2070.26,
    y1: 2525.5,
    x2: 2070.26,
    y2: 2482.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-37",
    x1: 1369.9,
    y1: 2525.5,
    x2: 1369.9,
    y2: 2482.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-38",
    x1: 697.11,
    y1: 2525.5,
    x2: 697.11,
    y2: 2482.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-39",
    x1: 187.56,
    y1: 2525.5,
    x2: 187.56,
    y2: 2482.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-40",
    x1: 2710.22,
    y1: 2525.5,
    x2: 2710.22,
    y2: 2482.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-41",
    x1: 155,
    y1: 2612.5,
    x2: 155,
    y2: 2569.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-42",
    x1: 1137.5,
    y1: 2655.5,
    x2: 1137.5,
    y2: 2612.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-43",
    x1: 1937.5,
    y1: 2655.5,
    x2: 1937.5,
    y2: 2612.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-44",
    x1: 369,
    y1: 2655.5,
    x2: 369,
    y2: 2612.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-45",
    x1: 187.5,
    y1: 2698.5,
    x2: 187.5,
    y2: 2655.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-46",
    x1: 773.5,
    y1: 2698.5,
    x2: 773.5,
    y2: 2655.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-47",
    x1: 1573.5,
    y1: 2698.5,
    x2: 1573.5,
    y2: 2655.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-48",
    x1: 2373.5,
    y1: 2698.5,
    x2: 2373.5,
    y2: 2655.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-49",
    x1: 2668.5,
    y1: 2655.5,
    x2: 2668.5,
    y2: 2612.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-50",
    x1: 405.5,
    y1: 2741.5,
    x2: 405.5,
    y2: 2698.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-51",
    x1: 1209.5,
    y1: 2741.5,
    x2: 1209.5,
    y2: 2698.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-52",
    x1: 2009.5,
    y1: 2741.5,
    x2: 2009.5,
    y2: 2698.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-53",
    x1: 2704.5,
    y1: 2741.5,
    x2: 2704.5,
    y2: 2698.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-54",
    x1: 2886.5,
    y1: 2698.5,
    x2: 2886.5,
    y2: 2655.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-55",
    x1: 405.5,
    y1: 2482.5,
    x2: 405.5,
    y2: 2439.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-56",
    x1: 1209.5,
    y1: 2482.5,
    x2: 1209.5,
    y2: 2439.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-57",
    x1: 2009.5,
    y1: 2482.5,
    x2: 2009.5,
    y2: 2439.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-58",
    x1: 2704.5,
    y1: 2482.5,
    x2: 2704.5,
    y2: 2439.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_184",
    x1: -18.75,
    y1: 1696.25,
    x2: 1490.25,
    y2: 187.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b15226"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#bd6237"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dd8a62"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_188",
    x1: -2594.25,
    y1: 1742.75,
    x2: -1038.75,
    y2: 187.25,
    gradientTransform: "matrix(-1, 0, 0, 1, 471, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b15226"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#bc6136"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#da865e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dd8a62"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_171",
    x1: 239,
    y1: 2445,
    x2: 239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ad5027"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#dc8863"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#db8661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#d6805a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#cd764f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#c0673e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#b05428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ad5024"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_171-2",
    x1: 2761,
    y1: 2445,
    x2: 2761,
    y2: 0,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_171"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "sans la chaudi\xE8re") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 2445,
    width: 3000,
    height: 555
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1303,
    width: 396,
    height: 608
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "parquet"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1109.5,
    y: 2828.5,
    width: 800,
    height: 43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 309.5,
    y: 2828.5,
    width: 800,
    height: 43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 2709.5,
    y: 2828.5,
    width: 290,
    height: 43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1909.5,
    y: 2828.5,
    width: 800,
    height: 43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 1537.5,
    y: 2784.5,
    width: 800,
    height: 43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 737.5,
    y: 2784.5,
    width: 800,
    height: 43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 0.5,
    y: 2784.5,
    width: 737,
    height: 43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 2337.5,
    y: 2784.5,
    width: 662,
    height: 43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 1720.08,
    y: 2741.5,
    width: 700.37,
    height: 43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 1019.71,
    y: 2741.5,
    width: 700.37,
    height: 43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 374.5,
    y: 2741.5,
    width: 645.21,
    height: 43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 0.5,
    y: 2741.5,
    width: 374.12,
    height: 43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 2420.45,
    y: 2741.5,
    width: 579.55,
    height: 43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 0.5,
    y: 2828.5,
    width: 309,
    height: 43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 737.5,
    y: 2871.5,
    width: 800,
    height: 43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 1537.5,
    y: 2871.5,
    width: 800,
    height: 43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 0.5,
    y: 2871.5,
    width: 737,
    height: 43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 0.5,
    y: 2914.5,
    width: 374,
    height: 43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 373.5,
    y: 2914.5,
    width: 800,
    height: 43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 1173.5,
    y: 2914.5,
    width: 800,
    height: 43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 1973.5,
    y: 2914.5,
    width: 800,
    height: 43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 2337.5,
    y: 2871.5,
    width: 662,
    height: 43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 0.5,
    y: 2957.5,
    width: 810,
    height: 43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 809.5,
    y: 2957.5,
    width: 800,
    height: 43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 1609.5,
    y: 2957.5,
    width: 800,
    height: 43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 2409.5,
    y: 2957.5,
    width: 590,
    height: 43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 2773.5,
    y: 2914.5,
    width: 226,
    height: 43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 1109.5,
    y: 2569.5,
    width: 800,
    height: 43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 309.5,
    y: 2569.5,
    width: 800,
    height: 43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 2709.5,
    y: 2569.5,
    width: 290,
    height: 43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 1909.5,
    y: 2569.5,
    width: 800,
    height: 43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 1537.5,
    y: 2525.5,
    width: 800,
    height: 43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 737.5,
    y: 2525.5,
    width: 800,
    height: 43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 0.5,
    y: 2525.5,
    width: 737,
    height: 43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 2337.5,
    y: 2525.5,
    width: 662,
    height: 43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 1720.08,
    y: 2482.5,
    width: 700.37,
    height: 43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 1019.71,
    y: 2482.5,
    width: 700.37,
    height: 43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 374.5,
    y: 2482.5,
    width: 645.21,
    height: 43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 0.5,
    y: 2482.5,
    width: 374.12,
    height: 43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 2420.45,
    y: 2482.5,
    width: 579.55,
    height: 43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 0.5,
    y: 2569.5,
    width: 309,
    height: 43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 737.5,
    y: 2612.5,
    width: 800,
    height: 43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 1537.5,
    y: 2612.5,
    width: 800,
    height: 43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 0.5,
    y: 2612.5,
    width: 737,
    height: 43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 0.5,
    y: 2655.5,
    width: 374,
    height: 43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 373.5,
    y: 2655.5,
    width: 800,
    height: 43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 1173.5,
    y: 2655.5,
    width: 800,
    height: 43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 1973.5,
    y: 2655.5,
    width: 800,
    height: 43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 2337.5,
    y: 2612.5,
    width: 662,
    height: 43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 0.5,
    y: 2698.5,
    width: 810,
    height: 43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 809.5,
    y: 2698.5,
    width: 800,
    height: 43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 1609.5,
    y: 2698.5,
    width: 800,
    height: 43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 2409.5,
    y: 2698.5,
    width: 590,
    height: 43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 2773.5,
    y: 2655.5,
    width: 226,
    height: 43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 0.5,
    y: 2439.5,
    width: 810,
    height: 43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 809.5,
    y: 2439.5,
    width: 800,
    height: 43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 1609.5,
    y: 2439.5,
    width: 800,
    height: 43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 2409.5,
    y: 2439.5,
    width: 590,
    height: 43
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-61",
    points: "478 2193 709 2168 1248 894 1303 602 1303 0 478 0 478 2193"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "2522 2286 2291 2168 1752 894 1697 602 1697 0 2522 0 2522 2286"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-63",
    points: "2362 2062 2362 1850 2236 1783 2236 1594 2147 1561 2147 1405 2077 1390 2077 1242 2020 1236 2020 1119 1974 1119 1974 1020 1937 1020 1937 934 1905 934 1905 863 1500 863 1095 863 1095 934 1063 934 1063 1020 1026 1020 1026 1119 980 1119 980 1236 923 1242 923 1390 853 1405 853 1561 764 1594 764 1783 638 1850 638 2062 478 2193 478 2445 1500 2445 2522 2445 2522 2193 2362 2062"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-63",
    points: "1784 851 1784 809 1772 809 1772 765 1761 765 1761 733 1746 733 1746 699 1738 699 1738 661 1729 661 1729 630 1721 630 1721 609 1500 609 1279 609 1279 630 1271 630 1271 661 1262 661 1262 699 1254 699 1254 733 1239 733 1239 765 1228 765 1228 809 1216 809 1216 851 1200 851 1200.04 863 1500 863 1799.96 863 1800 851 1784 851"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    width: 478,
    height: 2445
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 2522,
    width: 478,
    height: 2445
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-66",
    x1: 2522,
    x2: 2522,
    y2: 2237
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-66",
    x1: 478.5,
    x2: 478.5,
    y2: 2237
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-67",
    points: "478 2193 2522 2193 2362 2062 638 2062 478 2193"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-67",
    points: "638 1850 764 1783 2236 1783 2362 1850 638 1850"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-67",
    points: "764 1594 2236 1594 2147 1561 853 1561 764 1594"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-67",
    points: "853 1405 2147 1405 2077 1390 923 1390 853 1405"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-67",
    points: "923 1242 2077 1242 2020 1236 980 1236 923 1242"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-68",
    points: "471 2251.56 471 2193 638 2061 2362 2059 2528 2193 2528 2251.56 471 2251.56"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-69",
    x1: 470,
    y1: 2192.5,
    x2: 2529,
    y2: 2193.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 478,
    y: 2251.5,
    width: 2044.5,
    height: 27
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-68",
    points: "620.85 1912.56 620.85 1854 763.52 1783 2236.33 1781 2378.15 1854 2378.15 1912.56 620.85 1912.56"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-69",
    x1: 620,
    y1: 1853.5,
    x2: 2379,
    y2: 1854.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 638,
    y: 1912.5,
    width: 1724,
    height: 27
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-68",
    points: "727.75 1651.52 727.75 1595.03 853.06 1561.08 2146.69 1559.08 2271.25 1595.03 2271.25 1651.52 727.75 1651.52"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-69",
    x1: 727,
    y1: 1594.53,
    x2: 2272,
    y2: 1595.53
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 764,
    y: 1651.46,
    width: 1471.88,
    height: 26.97
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-68",
    points: "810.67 1464.52 810.67 1412.03 922.52 1390.08 2077.15 1388.08 2188.33 1412.03 2188.33 1464.52 810.67 1464.52"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-69",
    x1: 810,
    y1: 1411.53,
    x2: 2189,
    y2: 1412.53
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 853,
    y: 1464.46,
    width: 1293.78,
    height: 26.97
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-68",
    points: "878.6 1292.52 878.6 1245.03 979.42 1236.08 2020.18 1234.08 2120.4 1245.03 2120.4 1292.52 878.6 1292.52"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-69",
    x1: 878,
    y1: 1244.53,
    x2: 2121,
    y2: 1245.53
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 956,
    y: 1119.03,
    width: 1089,
    height: 37.97
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 1009,
    y: 1019.88,
    width: 983,
    height: 34.27
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-69",
    x1: 956,
    y1: 1118.14,
    x2: 2045,
    y2: 1119.32
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 923,
    y: 1292.46,
    width: 1153.71,
    height: 23.97
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 980,
    y: 1157.46,
    width: 1039.71,
    height: 23.97
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 1026,
    y: 1054.19,
    width: 947.71,
    height: 15.08
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 1047,
    y: 932.88,
    width: 907,
    height: 26.61
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 1062.69,
    y: 959.29,
    width: 874.44,
    height: 11.71
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 1079,
    y: 862.22,
    width: 843,
    height: 24.73
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 1093.58,
    y: 886.77,
    width: 812.73,
    height: 10.88
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 1189,
    y: 848.85,
    width: 623,
    height: 18.28
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 1206,
    y: 808.56,
    width: 589,
    height: 17.28
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 1216.19,
    y: 825.71,
    width: 567.85,
    height: 7.6
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 1218,
    y: 764.07,
    width: 565,
    height: 16.58
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 1227.77,
    y: 780.52,
    width: 544.71,
    height: 7.29
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 1229,
    y: 732.53,
    width: 543,
    height: 15.93
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 1238.39,
    y: 748.34,
    width: 523.5,
    height: 7.01
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 1245,
    y: 698.2,
    width: 511,
    height: 14.99
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 1253.84,
    y: 713.08,
    width: 492.65,
    height: 6.6
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 1254,
    y: 660.58,
    width: 493,
    height: 14.46
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 1262.53,
    y: 674.94,
    width: 475.3,
    height: 6.36
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 1263,
    y: 629.96,
    width: 475,
    height: 13.93
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 1271.21,
    y: 643.79,
    width: 457.95,
    height: 6.13
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 1271,
    y: 608.29,
    width: 459,
    height: 13.47
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 1278.94,
    y: 621.66,
    width: 442.52,
    height: 5.92
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSituationEscalier);
export default __webpack_public_path__ + "static/media/situation_escalier.9f9b34c2260e0fcd0bde33e22d854afd.svg";
export { ForwardRef as ReactComponent };